import { createAction } from '../../utils/helpers';
import * as actionTypes from './types';

export const startPolling = createAction(actionTypes.START_POLLING);
export const subscriptionFailed = createAction(actionTypes.SUBSCRIPTION_FAILED);
